import { ActionTypes } from "../constants/action-types";

export const lowerHeaderZIndex = (lowerHeaderZIndex) => {
  return {
    type: ActionTypes.LOWER_HEADER_Z_INDEX,
    payload: lowerHeaderZIndex,
  };
};

export const isSuperbrandHeroPresent = (isSuperbrandHeroPresent) => {
  return {
    type: ActionTypes.IS_SUPERBRAND_HERO_PRESENT,
    payload: isSuperbrandHeroPresent,
  };
};

export const isSubmenuVisible = (isSubmenuVisible) => {
  return {
    type: ActionTypes.IS_SUBMENU_VISIBLE,
    payload: isSubmenuVisible,
  };
};

export const isHeaderScroll = (isHeaderScroll) => {
  return {
    type: ActionTypes.IS_HEADER_SCROLL,
    payload: isHeaderScroll,
  };
};

export const isMenuVisible = (isMenuVisible) => {
  return {
    type: ActionTypes.IS_MENU_VISIBLE,
    payload: isMenuVisible,
  };
};

export const setSearchIcon = (value) => {
  return {
    type: ActionTypes.SET_SEARCH_ICON,
    payload: value,
  };
};

export const isPwaSubmenuVisible = (isPwaSubmenuVisible) => {
  return {
    type: ActionTypes.IS_PWA_SUBMENU_VISIBLE,
    payload: isPwaSubmenuVisible,
  };
};

export const isPwaShowShopMenu = (isPwaShowShopMenu) => {
  return {
    type: ActionTypes.IS_PWA_SHOW_SHOP_MENU,
    payload: isPwaShowShopMenu,
  };
};
